<div class="query-badge-container" [ngClass]="{ 'is-pivot': isPivot }">
  <div class="left-section">
    <ng-container *ngIf="isPivot; else regularIcon">
      <hyperkit-icon
      icon="shuffle"
      size="base"
      color="primary"
      class="pivot-icon"
    >
    </hyperkit-icon>
    <hyperkit-icon
    icon="code"
    size="base"
    color="primary"
    class="code-icon"
  >
  </hyperkit-icon>
    </ng-container>
    <ng-template #regularIcon>
      <hyperkit-icon
      icon="code"
      size="base"
      color="primary"
    >
    </hyperkit-icon>
    </ng-template>
    
    <div class="query-text">
      <hyperkit-typography class="endpoint-label" variant="label1" align="left" color="primary">{{ category }}</hyperkit-typography>
    </div>
  </div>
  
  <div class="right-section" *ngIf="isPivot">
    <div class="original-query">
      <hyperkit-tag
      class="parent-query"
      [mode]="'outline'"
      [closable]="false"
      [textLeft]="'Original Query'"
      [text]="parentQuery">
    </hyperkit-tag>
    </div>
  </div>
  
  <div class="right-section" *ngIf="!isPivot && numPivots > 0">
    <div class="pivot-count">
      <hyperkit-tag
      class="parent-query"
      [mode]="'outline'"
      [closable]="false"
      [textLeft]="'Pivot Queries'"
      [text]="numPivots.toString()">
    </hyperkit-tag>
    </div>
  </div>
</div>